import { useEffect, useState } from 'react';
import { analyzeLogo } from './analyzeLogo';
import './style.css';

export default function AdaptiveClientLogo({ src, alt }) {
  const [analysis, setAnalysis] = useState(null);

  useEffect(() => {
    let active = true;
    analyzeLogo(src).then(needsSurface => {
      if (active) setAnalysis({ src, needsSurface });
    });
    return () => { active = false; };
  }, [src]);

  const needsSurface = analysis?.src === src && analysis.needsSurface;
  return (
    <span className={`client-logo-surface${needsSurface ? ' client-logo-surface--neutral' : ''}`}>
      <img className="logo" src={src} alt={alt} />
    </span>
  );
}
